
import './App.css';
import HeroImage from "./components/HeroImage";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Skills from "./components/Skills";
import Project from "./components/Project";
import Statistics from "./components/Statistics";
import Contact from "./components/Contact";



function App() {
  return (
    <div className="App">
    {/* <div style={{height:"70px"}}></div> */}
     


     
     
     {/* <Navbar/>
     <Intro/>
     <Skill/>
     <Project/>
                           
     <Github/>
     <Stats/>
     <Contact/> */}
     
     
     <Navbar />
      <HeroImage />
      <About />
      <Skills />
      <Project />
      <Statistics />
      <Contact />
    
    

    
    </div>
  );
}

export default App;
